import { IUser, User } from '../types/user.type';

export interface IUserSession {
	user: IUser;
	authenticated: boolean;
	expires: Date;
	token: string;
}

export class UserSession implements IUserSession {
	user: IUser = new User();
	authenticated: boolean = false;
	expires: Date = null;
	token: string = null;
}
